import React, { useCallback, useEffect } from "react";
import Header from "../Header";
import ProgressHeader from "./ProgressHeader";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import ColoredIcon from "../ColoredIcon";
import Checkmark from "../../img/Ok_flag.svg";
import { getEnvironment } from "../../utils/getEnvironment";
import { useCookies } from "react-cookie";
import { getAppLanguage } from "../../utils/languageUtils";
import { useNavigate } from "react-router-dom";
import BottomButton from "../BottomButton";
import ContentAreaWrapper from "../ContentAreaWrapper";

const environment = getEnvironment();

const Completed = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const [cookies] = useCookies(["creation_uuid"]);

    useEffect(() => {
        if (!cookies.creation_uuid) {
            navigate("/creation/signup");
        }
    }, [cookies, navigate]);

    const onNext = useCallback(() => {
        if (!cookies.creation_uuid) return;

        // Get the current WeGlot language
        const currentLanguage = getAppLanguage();

        // Generate the redirect URL with the language parameter
        const redirectUrl = `${environment.admin_address}/redirect/${cookies.creation_uuid}?lang=${currentLanguage}`;

        // Perform the redirection
        window.location.href = redirectUrl;
    }, [cookies]);

    return (
        <Stack height="100%" width="100%" alignItems="center">
            <Header />
            <ProgressHeader step={2} title="Create Account" />
            <ContentAreaWrapper>
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    minHeight="90%"
                    gap={2}
                    px={6}
                    pt={2}
                    textAlign="center"
                >
                    <Typography
                        fontWeight={700}
                        fontSize="24px"
                        lineHeight="28.8px"
                        textAlign="center"
                        color="primary"
                    >
                        Thank you for your patience!
                    </Typography>
                    <Stack alignItems="center">
                        <Typography
                            fontWeight={300}
                            fontSize="14px"
                            lineHeight="18.2px"
                            textAlign="center"
                            sx={{ opacity: "80%" }}
                        >
                            You’re doing great! Your account has been created.{" "}
                        </Typography>
                        <Typography
                            fontWeight={300}
                            fontSize="14px"
                            lineHeight="18.2px"
                            textAlign="center"
                            sx={{ opacity: "80%" }}
                        >
                            Now, let's jump into adding your services and
                            setting up your schedule!
                        </Typography>
                    </Stack>
                    <ColoredIcon
                        icon={Checkmark}
                        color={theme.palette.primary.main}
                        size="96px"
                        style={{
                            padding: "15px",
                        }}
                    />
                </Box>
            </ContentAreaWrapper>
            <BottomButton onClick={onNext}>Go to Pricelist</BottomButton>
        </Stack>
    );
};

export default Completed;
